module.exports = __webpack_public_path__ + "static/media/distribute.93997ec3.webp";